import {DashboardStateModel} from './dashboard-state.model';

export class ToggleDashboardFeature {
  static readonly type = '[Dashboard] Toggle Feature';
  constructor(public features: Partial<DashboardStateModel> = {}) {}
}
